import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './_store';
import { Provider } from 'react-redux';

const useStrictMode = process.env.REACT_APP_USE_STRICT_MODE === 'true';

const root = ReactDOM.createRoot(document.getElementById('root'));

useStrictMode
    ? root.render(
          <React.StrictMode>
              <Provider store={store}>
                  <BrowserRouter>
                      <App />
                  </BrowserRouter>
              </Provider>
          </React.StrictMode>
      )
    : root.render(
          <Provider store={store}>
              <BrowserRouter>
                  <App />
              </BrowserRouter>
          </Provider>
      );

reportWebVitals();
